export default function CTA() {
  return (
    <section className="py-36 bg-white">
      <div className="max-w-7xl mx-auto px-8 text-center">
        <h2 className="text-5xl font-bold text-black mb-6">
          Ready to Enhance Your iOS Experience?
        </h2>
        <p className="text-lg text-gray-600 mb-12">
          Join thousands of satisfied users protecting their devices
        </p>
        
        <div className="relative mt-16 overflow-hidden">
          <div className="flex items-center justify-center gap-8">
            <div className="w-64 h-96 rounded-3xl overflow-hidden shadow-2xl transform -rotate-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/8af38b67a4b73b727b1a58f4baad3635.jpg" 
                alt="VPN App Interface"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-64 h-96 rounded-3xl overflow-hidden shadow-2xl transform rotate-3 scale-110 z-10">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20displaying%20Cleaner%20application%20interface%20with%20bright%20colorful%20storage%20analysis%20dashboard%20showing%20file%20categories%20and%20cleanup%20options%2C%20professional%20product%20photography%20on%20clean%20white%20background%20with%20soft%20shadows%2C%20modern%20iOS%20app%20design%20featuring%20circular%20progress%20charts%20and%20vibrant%20accent%20colors%2C%20premium%20mobile%20application%20screenshot%20with%20intuitive%20optimization%20controls&width=300&height=600&seq=cta2&orientation=portrait" 
                alt="Cleaner App Interface"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="w-64 h-96 rounded-3xl overflow-hidden shadow-2xl transform -rotate-3">
              <img 
                src="https://readdy.ai/api/search-image?query=iPhone%20showing%20VPN%20application%20settings%20screen%20with%20server%20list%20and%20connection%20options%2C%20professional%20product%20photography%20with%20studio%20lighting%20on%20clean%20white%20background%2C%20modern%20dark%20themed%20iOS%20interface%20with%20organized%20menu%20layout%20and%20toggle%20switches%2C%20premium%20mobile%20app%20screenshot%20displaying%20global%20server%20locations%20with%20connection%20speed%20indicators&width=300&height=600&seq=cta3&orientation=portrait" 
                alt="App Settings"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
